<template>
  <div class="product-details-content-register-module">
    <h5 class="text-semibold mb-5">Cartaz horizontal</h5>
    <div class="row">
      <div class="col-lg-4">
        <snow-input-file
          v-model="form.picture"
          isImage
          background-color="bg-1"
          id="image-horizontal"
          title="Cartaz horizontal"
          dimensions="686x414"
        />
      </div>
      <div class="col-lg-6 d-lg-flex d-none">
        <img src="@/assets/images/member-area/tab-placeholder-horizontal.svg" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
